
import EmptyState from "@/components/EmptyState.vue";
import HeaderFilter from "@/components/HeaderFilter.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import ListDefault from "@/components/ListDefault.vue";
import TabsEvent from "@/components/TabsEvent.vue";
import TabsHome from "@/components/TabsHome.vue";
import TextLink from "@/components/TextLink.vue";
import ThreeOptionsListExtract from "@/components/ThreeOptionsListExtract.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import moment from "moment";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    HeaderFluxo,
    ListDefault,
    ThreeOptionsListExtract,
    TextLink,
    HeaderFilter,
    EmptyState,
    HeaderRelease,
    TabsHome,
    TabsEvent,
    HeaderColor,
  },
})
export default class Extrato extends Vue {
  pedidos: any = JSON.parse(sessionStorage.getItem("ORDERS_EXTRATO") || "[]");
  initialDate: string = sessionStorage.getItem("INITIAL_DATE") || "";
  finalDate: string = sessionStorage.getItem("FINAL_DATE") || "";
  totalMonth = 0;
  period: string = sessionStorage.getItem("PERIOD_FILTERED") || "";
  today: any = moment();
  lastDayOfMonth: any = moment().add("months", 1).date(0);
  endOfMonth: any;
  startOfMonth: any;
  startOfThreeMonth: any;
  lastSevenDays: any;
  pedidosEsteMes: any = JSON.parse(
    sessionStorage.getItem("ORDERS_MONTH") || "[]"
  );
  pedidosRecentes: any = JSON.parse(
    sessionStorage.getItem("ORDERS_RECENTS") || "[]"
  );
  pedidosDeTresMeses: any = JSON.parse(
    sessionStorage.getItem("ORDERS_THREE_MONTHS") || "[]"
  );
  calendar: any = {
    dates: [
      { id: "0", NAME: "Recentes", IDTAB: "RECENTES" },
      { id: "1", NAME: "Este Mês", IDTAB: "ESTE_MES" },
      { id: "2", NAME: "3 Meses", IDTAB: "TRES_MESES" },
    ],
  };

  notFound = false;
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };
  tab: any = null;
  cameFromConfirmCode = JSON.parse(
    sessionStorage.getItem("CAME_FROM_CONFIRM_CODE") || "false"
  );

  getTituloItemExtrato(pedido: any) {
    return pedido.paymentMethod === "CC_W"
      ? "Compra de Saldo"
      : pedido.eventName;
  }

  letraI(pedido: any) {
    const letra = pedido.eventName;
    const letraInicial = letra.substring(0, 1);
  }

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
    // $("#tabs").tabs();
    const period = sessionStorage.getItem("PERIOD_FILTERED") || "";
    if (period == "") {
      sessionStorage.setItem(
        "PERIOD_FILTERED",
        "" + moment().format("MM/YYYY")
      );
      this.period = sessionStorage.getItem("PERIOD_FILTERED") || "";
    }
    var now = moment();
    this.getFirstAndLastDayOfMonth();
    this.getlastSevenDays();
    this.getThreeMonthsDate();
  }

  beforeDestroy() {
    sessionStorage.setItem("INITIAL_DATE", "");
    sessionStorage.setItem("FINAL_DATE", "");
    sessionStorage.setItem("PERIOD_FILTERED", "" + moment().format("MM/YYYY"));
  }

  retrieveDate(stringDate: string) {
    const arr = stringDate.split("/");
    const ano = Number(arr[2]),
      mes = Number(arr[1]) - 1,
      dia = Number(arr[0]);
    return new Date(ano, mes, dia);
  }

  getFirstAndLastDayOfMonth() {
    var month = moment().month();
    var year = moment().year();
    const startOfMonth = moment(moment().month(month).year(year))
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth = moment(moment().month(month).year(year))
      .endOf("month")
      .format("YYYY-MM-DD");
    this.endOfMonth = endOfMonth;
    this.startOfMonth = startOfMonth;
  }

  getThreeMonthsDate() {
    const threeMonths = moment().subtract(3, "months").month();
    const month = moment().month();
    const year = moment().year();
    const startOfThreeMonth = moment(
      moment()
        .month(threeMonths)
        .year(year - 1)
    )
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth = moment(moment().month(month).year(year))
      .endOf("month")
      .format("YYYY-MM-DD");
    this.startOfThreeMonth = startOfThreeMonth;
    this.loadOrders(startOfThreeMonth, endOfMonth);
  }

  getlastSevenDays() {
    const lastSevenDays = moment().subtract(7, "d").format("YYYY-MM-DD");
    this.lastSevenDays = lastSevenDays;
    console.log(lastSevenDays);
  }

  filterOneMonthOrders(orders: any) {
    let currentOrders = orders.filter((o: any) =>
      moment(o.createDate.date).isSameOrAfter(this.startOfMonth)
    );
    return currentOrders;
  }

  filterDayOrders(orders: any) {
    let currentOrdersDay = orders.filter((o: any) =>
      moment(o.createDate.date).isSameOrAfter(this.lastSevenDays)
    );
    return currentOrdersDay;
  }

  filterThreeMonthsOrders(orders: any) {
    let currentOrdersDay = orders.filter((o: any) =>
      moment(o.createDate.date).isSameOrAfter(this.startOfThreeMonth)
    );
    return currentOrdersDay;
  }

  loadOrders(initial: any, final: any) {
    try {
      const self = this;
      const req = new Request();

      const body: any = {
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        USER_ID: sessionStorage.getItem("USER_ID"),
        // PAYMENT_METHOD: "CC",
      };

      req.body = body;

      if (initial) {
        body.INITIAL_DATE = initial;
      }
      if (final) {
        body.FINAL_DATE = final;
      }

      req.route = "listOrders";
      req.callbackSuccess = function (response: any) {
        self.pedidos = response.orders;
        self.pedidosEsteMes = self.filterOneMonthOrders(response.orders);
        self.pedidosRecentes = self.filterDayOrders(response.orders);
        self.pedidosDeTresMeses = self.filterThreeMonthsOrders(response.orders);

        // self.pedidos.forEach((pedido: any) => {
        //   if (pedido.paymentStatus == "A") self.totalMonth += pedido.total;
        //   if (pedido.paymentStatus == "R") self.totalMonth -= pedido.total;
        // });
        if (!self.initialDate)
          sessionStorage.setItem(
            "ORDERS_EXTRATO",
            JSON.stringify(response.orders)
          );
        sessionStorage.setItem(
          "ORDERS_MONTH",
          JSON.stringify(self.pedidosEsteMes)
        );
        sessionStorage.setItem(
          "ORDERS_RECENTS",
          JSON.stringify(self.pedidosRecentes)
        );
        sessionStorage.setItem(
          "ORDERS_THREE_MONTHS",
          JSON.stringify(self.pedidosDeTresMeses)
        );

        if (self.pedidos.length == 0) self.notFound = true;
        else self.notFound = false;
      };
      req.callbackError = function (error: any) {
        console.log(error);
        self.notFound = true;
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  formatDate(stringDate: number) {
    const momentDate: any = moment(stringDate);
    return momentDate.lang("pt-br").format("DD/MM/YYYY [às] HH:mm");
  }

  goBack() {
    if (this.cameFromConfirmCode) {
      sessionStorage.setItem("CAME_FROM_CONFIRM_CODE", "false");
      this.$router.go(-3);
    } else {
      this.$router.go(-2);
    }
  }

  goTo() {
    this.$router.push({ name: "FiltroExtrato" });
  }
}
